import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { FavoriteList, NewFavoriteList } from "./types"

export interface FavouritesListSearchParams {
  date: string | null
  favouriteListIds: string[] | null
  guestCount?: number | null
  numberOfdays?: number | null
}

export interface FavoriteListSearchRequest extends Partial<AxiosRequestConfig> {
  params: FavouritesListSearchParams
}

export interface FavouritesListSearchResponseData extends ResponseData {
  data: FavoriteList[]
}
export interface FavouritesListSearchResponse extends AxiosResponse {
  data: FavouritesListSearchResponseData
}

// ------------------  new api optimized version ---------------------------

export interface GetFavouritesListResponseDataNew extends ResponseData {
  data: NewFavoriteList[]
}
export interface GetFavouritesListResponseNew extends AxiosResponse {
  data: GetFavouritesListResponseDataNew
}

export function searchFavoriteListsOptimizedApi(
  { params }: FavoriteListSearchRequest,
  axiosInstance: AxiosInstance,
): Promise<GetFavouritesListResponseNew> {
  const url = `/user/favouritelist/search/properties`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<GetFavouritesListResponseNew>
}
